export default {
    dashboard: {
        totalWordsGenerated: 'Total de palabras generadas',
        wordsPerDay: 'Palabras/día',
        content: 'Contenido',
        date: 'Fecha',
        variationCount: 'Recuento de variantes',
        transactionId: 'ID de Transacción',
        totalWordsCount: 'Recuento del total de palabras',
        action: 'Acción',
        goTo: 'Ir a',
        viewMore: 'Ver más',
        showLess: 'Mostrar menos',
        tabImage: 'Imagen',
        tabText: 'Texto',
        dashboardSubtitle: 'Administra tu contenido generado por inteligencia artificial',
        type: 'Tipo',
    },
};
